import request from '@/utils/request'

export function currentUser () {
  return request({
    url: 'login/currentUser',
    method: 'get'
  })
}

export function getMenu (userId) {
  return request({
    url: 'menu/asideMenu',
    method: 'get',
    params: {
      userId: userId
    }
  })
}

export function login (tel, password) {
  return request({
    url: 'login/in',
    method: 'post',
    data: {
      tel: tel,
      password: password
    }
  })
}

export function loupdatePwdgin (data) {
  return request({
    url: 'login/updatePwd',
    method: 'post',
    data
  })
}

export function queryReportTaskList (data) {
  return request({
    url: 'reportTask/queryReportTaskList',
    method: 'post',
    data
  })
}
